// Central place for external links + actions used across the site.
// Update the booking / social URLs here and every button stays in sync.

export const BOOKING_URL = "https://bookings.asiatech.in/?page=10162&type=website";
export const INSTAGRAM_URL = "https://www.instagram.com/camphornbillcorbett";

export const openBooking = () =>
  window.open(BOOKING_URL, "_blank", "noopener,noreferrer");

export const openInstagram = () =>
  window.open(INSTAGRAM_URL, "_blank", "noopener,noreferrer");
